<template>
	<div class="text-center text-italic q-my-md-lg text-weight-bold">
		Congratulations!<br>
        Here is your <span class="text-blue">MEMO LINK</span>
	</div>
	<div class="bg-grey-3 text-italic q-pa-sm text-center text-weight-bold q-mt-lg">
		<span class="text-blue">https://</span>
		<span v-if="props.memoLink.subdomain?.name ?? null" class="text-deep-orange">{{ props.memoLink.subdomain.name.toUpperCase() }}.</span>
		<span class="text-blue">{{ appDomain }}/</span>
		<span class="text-blue-5"
		      v-html="colorizeWords(props.memoLink.words,'-',true)"></span>
	</div>
	<div class="text-center">
		<q-icon name="fa-regular fa-clone" class="text-red q-mr-md"/>
		<a class="text-red"
		   href="javascript:void(0);"
		   @click="copyTextToClipboard(url(
           props.memoLink.words.map((item) => capitalize(item.toLowerCase())).join('-'),
           props.memoLink.subdomain?.name.toUpperCase() ?? null
           ))">
            Click here to copy it to your clipboard
		</a>
	</div>

	<div class="row q-my-lg full-width">
		<q-banner inline-actions rounded
		          class="col-sm-10 offset-sm-1 col-md-8 offset-md-2 bg-positive text-white text-justify q-pa-sm">
			<template v-slot:avatar>
				<q-icon name="fa-solid fa-hourglass-start" class="self-center full-height"/>
			</template>
			<p class="text-h7">
				This link will expire on
				<strong><u>{{ date.formatDate(new Date(props.memoLink.expires_at), 'DD/MM/YYYY') }}</u></strong>
			</p>
			go to
			<router-link :to="{name:'memo-link.list'}" class="route-link">My Memo Links</router-link>
			to manage the expiration of your Memo Links
		</q-banner>
	</div>

	<div v-if="props.memoLink.subdomain?.name ?? null" class="text-center text-italic text-weight-bold q-mt-xl row">
		<p class="q-mb-md col-12">Your Domain is:</p>
		<div class="flex justify-center q-mx-auto col-12 col-md-8 offset-md-2">
			<q-badge class="q-py-sm q-px-lg q-mx-md text-weight-bold q-mb-md"
			         color="grey-3"
			         text-color="deep-orange">
				{{ props.memoLink.subdomain?.name?.toUpperCase() ?? '' }}
			</q-badge>
		</div>
	</div>

	<div class="text-center text-italic text-weight-bold q-mt-xl row">
		<p class="q-mb-md col-12">Your Keywords are:</p>
		<div class="flex justify-center q-mx-auto col-12 col-md-8 offset-md-2">
			<q-badge v-for="word in props.memoLink.words"
			         class="q-py-sm q-px-lg q-mx-md text-weight-bold q-mb-md"
			         color="grey-3"
			         text-color="deep-orange">
				{{ capitalize(word.toLowerCase()) }}
			</q-badge>
		</div>
	</div>

	<div class="text-center q-mt-md">
		<q-btn color="primary" icon="fa-solid fa-plus" label="Create another Memo Link"
		       @click="eventBus.emit('reset-ml-form')"/>
	</div>

</template>

<script setup>
import {format, date, useQuasar} from 'quasar';
import {colorizeWords, url, copyTextToClipboard} from "../../../includes/helpers";
import {useStore} from 'vuex'
import LoginDialog from "../../../includes/dialogs/LoginDialog";
import { computed, inject } from 'vue'

const {capitalize} = format;
const quasar = useQuasar();
const store = useStore();
const eventBus = inject('eventBus');
const appDomain = inject('appDomain');

const limits = computed(() => store.getters.getLimits)
const subdomainExpiration = computed(() => parseInt(limits?.value?.getSubdomainExpiration()?.value))

const props = defineProps(['memoLink']);

function openDialog() {
    quasar.dialog({
        component: LoginDialog,
        componentProps: {
            memoLinkId: props.memoLink.id
        }
    });
}
</script>

<style>
div.q-banner__avatar.items-center.self-start {
	align-self: center;
}

a.route-link {
	color: inherit;
	text-decoration: none;
	border-bottom: 1px dashed;
}
.q-stepper--vertical .q-stepper__step:last-child .q-stepper__step-inner{
    padding: 0 20px 32px 20px;
}
</style>
